import { VStack } from '@astryxdesign/core/VStack';
import { HStack } from '@astryxdesign/core/HStack';
import { Heading } from '@astryxdesign/core/Heading';
import { Text } from '@astryxdesign/core/Text';
import { Card } from '@astryxdesign/core/Card';
import { Button } from '@astryxdesign/core/Button';
import { useTenant } from '../../app/tenant-context';
import { imageUrl } from '../../lib/public-api';
import { Empty } from '../../components/StateViews';
import { formatDuration, formatMoney } from '../../../supabase/functions/_shared/domain/format.ts';

export function ServicesPage() {
  const { sf, openBooking } = useTenant();
  const groups = new Map<string, typeof sf.services>();
  for (const s of sf.services) groups.set(s.category || 'Услуги', [...(groups.get(s.category || 'Услуги') ?? []), s]);

  return (
    <VStack gap={6} padding={4} className="page safe-top">
      <Heading level={1}>Услуги и цены</Heading>
      {sf.services.length === 0 ? <Empty title="Услуги скоро появятся" description="Позвоните в студию, чтобы записаться." /> : null}
      {[...groups.entries()].map(([cat, list]) => (
        <VStack key={cat} gap={3} as="section" aria-label={cat}>
          <Heading level={2}>{cat}</Heading>
          {list.map((s) => {
            const img = imageUrl(sf, s.image_path);
            return (
              <Card key={s.id} padding={0}>
                {img ? (
                  <div style={{ aspectRatio: '16 / 7', overflow: 'hidden', borderTopLeftRadius: 'inherit', borderTopRightRadius: 'inherit' }}>
                    <img className="media" src={img} alt="" loading="lazy" decoding="async" />
                  </div>
                ) : null}
                <VStack gap={2} padding={4}>
                  <HStack hAlign="between" vAlign="start" gap={3}>
                    <Text weight="semibold" type="large">{s.name}</Text>
                    <Text weight="semibold" className="tabular" textWrap="nowrap">{formatMoney(s.price_cents, sf.tenant.currency, s.price_is_from)}</Text>
                  </HStack>
                  {s.description ? <Text type="supporting">{s.description}</Text> : null}
                  <HStack hAlign="between" vAlign="center">
                    <Text type="supporting">{formatDuration(s.duration_minutes)}</Text>
                    <Button label="Записаться" variant="primary" size="sm" onClick={() => openBooking(s.id)} />
                  </HStack>
                </VStack>
              </Card>
            );
          })}
        </VStack>
      ))}
    </VStack>
  );
}
